import { type FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine } from '@fortawesome/free-solid-svg-icons';

const BaselinePerformanceMock: FC = () => (
  <div className="rounded-lg overflow-hidden shadow-2xl shadow-black/30 border border-white/[0.06] font-mono" style={{ background: '#0f1923' }}>
    <div className="p-3">
      <div className="bg-[#181825] border border-white/[0.06] rounded-lg overflow-hidden">
        <div className="flex items-center justify-between px-4 py-2.5 border-b border-white/[0.06]">
          <div className="flex items-center gap-2">
            <FontAwesomeIcon icon={faChartLine} className="text-sm text-blue-400" />
            <h3 className="text-sm font-medium text-gray-300 uppercase tracking-wide">Baseline Performance</h3>
          </div>
          <span className="text-[10px] text-gray-500">BTCUSDT &middot; 4h &middot; 2021-2024</span>
        </div>
        <div className="grid grid-cols-3 gap-px bg-white/[0.03]">
          {[
            { label: 'Sharpe Ratio', value: '1.24', sub: 'Risk-adjusted', color: 'text-white' },
            { label: 'Win Rate', value: '42.3%', sub: '68 / 161 trades', color: 'text-white' },
            { label: 'Profit Factor', value: '1.87', sub: 'Gross P / Gross L', color: 'text-white' },
            { label: 'Max Drawdown', value: '-18.4%', sub: 'Peak to trough', color: 'text-amber-400' },
            { label: 'Expectancy', value: '+0.42%', sub: 'Per trade', color: 'text-emerald-400' },
            { label: 'Payoff Ratio', value: '2.56', sub: 'Avg win / Avg loss', color: 'text-white' },
          ].map((m) => (
            <div key={m.label} className="px-4 py-3 bg-[#181825]">
              <div className="text-[9px] text-gray-500 uppercase tracking-wider mb-1">{m.label}</div>
              <div className={`text-lg font-semibold ${m.color}`}>{m.value}</div>
              <div className="text-[10px] text-gray-500 mt-0.5">{m.sub}</div>
            </div>
          ))}
        </div>
        <div className="px-4 py-2 border-t border-white/[0.06] flex items-center justify-between text-[10px] text-gray-500">
          <span>Total Return: +112.4%</span>
          <span>161 trades &middot; 1,095 days</span>
        </div>
      </div>
    </div>
  </div>
);

export default BaselinePerformanceMock;
